export class User {
  password?: string;
  token?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  country?: string;
  mobilePhoneNumber?: string;
  address?: string;
  addressExtra?: string;
  city?: string;
  zip?: string;
  state?: string;
  appId?: string;
}

export class Auth {
  userId: string;
  refreshToken?: string;
  accessToken?: string;
  expiresIn?: number;
  roles?:any;
}
